let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9aM7M")).then(() => parcelRequire('kIPzK'));